import React from 'react'
import styled from 'styled-components/macro'
import { Container, Icon, Text } from 'roadie-ui'
import { RecognitionKey } from 'data/senderRecognitions'

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;
  width: fit-content;
  max-width: 100%;
  padding: 1.2rem 2rem;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 1.2rem;
  gap: 0.8rem;
`

const ICON_SIZE = '6.4rem'
const BUBBLE_HEIGHT = '2rem'

const IconWithCount = styled.div`
  position: relative;
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  /* reserve the half of the count bubble that hangs below the icon */
  margin-bottom: calc(${BUBBLE_HEIGHT} / 2);
`

const CountBubble = styled.span`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${BUBBLE_HEIGHT};
  padding: 0.3rem 0.5rem;
  border: 1px solid ${(props) => props.theme.colors.primaryLighter};
  border-radius: 1.2rem;
  background: ${(props) => props.theme.colors.white};
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.6rem;
  color: ${(props) => props.theme.colors.greyDarker};
  white-space: nowrap;
`

type RecognitionTileProps = {
  recognitionKey: RecognitionKey
  title: string
  count: number
}

const RECOGNITION_ICON: Record<RecognitionKey, typeof Icon.FistBump> = {
  extra_helpful: Icon.FistBump,
  fast_delivery: Icon.TruckTimely,
  clean_vehicle: Icon.SparklingVehicle,
  great_photo: Icon.PhotoStar,
  delivered_with_care: Icon.HandHeart,
  friendly: Icon.SmileyFace,
  professional: Icon.Briefcase,
}

export const RecognitionTile: React.FC<RecognitionTileProps> = ({ recognitionKey, title, count }) => {
  const RecognitionIcon = RECOGNITION_ICON[recognitionKey]

  return (
    <Tile>
      <IconWithCount>
        <Container.Position $position="absolute" $top="0" $bottom="0" $left="0" $right="0">
          <Container.Base $borderRadius="100%" $backgroundColor="primary-lighter" $height="100%" />
        </Container.Position>
        <Container.Position $position="absolute" $top="0" $left="0" $right="0" $padding="0.8rem">
          <RecognitionIcon $color="neutral-black" $width="4.8rem" $height="4.8rem" />
        </Container.Position>
        <CountBubble>{count.toLocaleString()}</CountBubble>
      </IconWithCount>
      <Text.Body2 $color="neutral-black" $textAlign="center" $whiteSpace="nowrap">
        {title}
      </Text.Body2>
    </Tile>
  )
}
